import CityPageTemplate from "../city-template/CityPageTemplate";
import { dallasConfig } from "./data";

export default function DallasPage() {
  return <CityPageTemplate config={dallasConfig} />;
}